// components/assigned-tasks/AssignedTasksSection.jsx
import { useEffect, useState } from "react";
import AssignedTaskItem from "./AssignedTasksPrjSection";
import RetroButton from "../retro/button/retro-button.component";
import { BsListNested } from "react-icons/bs";

import "./assigned-tasks.styles.scss";

const AssignedTasksSection = ({
  spaceId,
  stationData,
  color,
  name,
  assignedColTasks,
  expandAll,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (expandAll !== null) {
      setIsOpen(expandAll);
    }
  }, [expandAll]);

  return (
    <div className={`personalItem_WSDetails ${isOpen ? "open" : ""}`}>
      <button
        type="button"
        className="personalItem_WSSummary"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className="at__fromspace-list-btn">
          <RetroButton style={{ background: color }}>
            {name.charAt(0)}
          </RetroButton>
          <h4>{name}</h4>
        </div>
      </button>

      <div className="wsDetailsContent">
        <div className="wsDetailsContent_Inner">
          {stationData?.map((project) => (
            <AssignedTaskItem
              key={project.id}
              project={project}
              assignedColTasks={assignedColTasks}
              color={color}
              expandAll={expandAll}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AssignedTasksSection;
